import { render, staticRenderFns } from "./TabbarLayout.vue?vue&type=template&id=3556b4e2&scoped=true"
import script from "./TabbarLayout.vue?vue&type=script&lang=js"
export * from "./TabbarLayout.vue?vue&type=script&lang=js"
import style0 from "./TabbarLayout.vue?vue&type=style&index=0&id=3556b4e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556b4e2",
  null
  
)

export default component.exports